"use client";

import { useRouter } from "next/navigation";
import { useActionState, useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { toast } from "@/components/toast";
import Link from "next/link";

import { AuthForm } from "@/components/auth-form";
import { SubmitButton } from "@/components/submit-button";

import { login, type LoginActionState } from "../actions";

import Logo from "@/components/Logo";

export default function Page() {
  const router = useRouter();
  const t = useTranslations("auth");

  const [email, setEmail] = useState("");
  const [isSuccessful, setIsSuccessful] = useState(false);

  const [state, formAction] = useActionState<LoginActionState, FormData>(
    login,
    {
      status: "idle",
    }
  );

  useEffect(() => {
    if (state.status === "failed") {
      toast({
        type: "error",
        description: t("invalidCredentials"),
      });
    } else if (state.status === "invalid_data") {
      toast({
        type: "error",
        description: t("invalidData"),
      });
    } else if (state.status === "success") {
      setIsSuccessful(true);
      router.refresh();
    }
  }, [state.status, router, t]);

  const handleSubmit = (formData: FormData) => {
    setEmail(formData.get("email") as string);
    formAction(formData);
  };

  return (
    <div className="flex h-dvh w-screen items-start pt-12 md:pt-0 md:items-center justify-center bg-background">
      <div className="w-full max-w-md overflow-hidden rounded-2xl flex flex-col gap-12">
        <div className="flex flex-col items-center justify-center gap-2 px-4 text-center sm:px-16">
          <Logo />
          <p className="text-sm text-gray-500 dark:text-zinc-400">
            {t("loginDescription")}
          </p>
        </div>
        <AuthForm action={handleSubmit}>
          <SubmitButton isSuccessful={isSuccessful}>{t("login")}</SubmitButton>
          <p className="text-center text-sm text-gray-600 mt-4 dark:text-zinc-400">
            {t("dontHaveAccount")}{" "}
            <Link
              href="/register"
              className="font-semibold text-gray-800 hover:underline dark:text-zinc-200"
            >
              {t("signUp")}
            </Link>
          </p>
        </AuthForm>
      </div>
    </div>
  );
}
